import { __generator } from "tslib";
import { call, select, delay } from 'redux-saga/effects';
import { getGallectionById } from '../selectors';
import { request } from '../../xhr';
function setGallectionName(action) {
    var _a, folderId, name, gallection, params;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, delay(500)];
            case 1:
                _b.sent(); // + takeLatest = debounced
                _a = action.payload, folderId = _a.folderId, name = _a.name;
                return [4 /*yield*/, select(function (state) { return getGallectionById(state, folderId); })];
            case 2:
                gallection = _b.sent();
                params = {
                    type: gallection.type,
                    folderid: gallection.folderId,
                    name: name,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/rename',
                        data: params,
                    })];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default setGallectionName;
//# sourceMappingURL=saveChangedGallectionName.js.map